module.exports = __webpack_public_path__ + "zvetseni-prsou_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_3_before.jpg
// module id = 1332
// module chunks = 0